/**
 * Resolves a `?redirect=` value to a same-origin path, or `/`.
 *
 * Parsed with `URL` rather than matched with a regex: the parser is what
 * the browser uses, so `//evil.com`, `/\evil.com` and `/\t/evil.com`
 * (tabs are stripped, leaving `//evil.com`) all resolve cross-origin and
 * are dropped here exactly as they would be followed there. The value
 * travels beyond `navigate()` — the login page's magic link carries it
 * through `emailRedirectTo` — so the check cannot lean on the router
 * treating it as a path.
 *
 * A same-origin result can still have a pathname that reads as
 * protocol-relative once it is used as a URL on its own: `/..//evil.com`
 * resolves to the pathname `//evil.com`. Those are dropped too.
 */
export function safeRedirectPath(
  raw: string | null | undefined,
  origin: string = window.location.origin,
): string {
  if (!raw || !raw.startsWith("/")) return "/";
  try {
    const url = new URL(raw, origin);
    if (url.origin !== origin) return "/";
    if (/^\/[/\\]/.test(url.pathname)) return "/";
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/";
  }
}
